import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Downloads from './components/Downloads';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Particles from './components/Particles';
import Footer from './components/Footer';
import Terms from './components/Terms';
import Updates from './components/Updates';
import './App.css';

function Home() {
  return (
    <>
      <Hero />
      <Downloads />
      <Pricing />
      <Testimonials />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Particles />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/updates" element={<Updates />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

